/**
 * Bundle Builder – scoped per section, vanilla JS.
 * State: bundle size, selected items, frequency, selling plan.
 * Updates UI (slots, progress, prices), adds to cart via theme routes.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (cents == null) return 'Unavailable';
    if (typeof window.theme === 'undefined' || !window.theme.moneyFormat) {
      return '$' + (cents / 100).toFixed(2);
    }
    var format = window.theme.moneyFormat;
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function getDiscountCents(root, size) {
    var key = 'discount-' + size;
    var val = root.getAttribute('data-' + key);
    return val ? parseInt(val, 10) : 0;
  }

  /**
   * Parsed from bundle-builder.liquid (ActiveSellingPlanGroupIds). Empty/absent = no client-side filter.
   */
  function parseActiveSellingPlanGroupIds(root) {
    var raw = root.getAttribute('data-active-selling-plan-group-ids');
    if (!raw || !String(raw).trim()) return null;
    var ids = String(raw)
      .split(',')
      .map(function (s) {
        return String(s).trim();
      })
      .filter(function (id) {
        return id.length > 0;
      });
    return ids.length ? ids : null;
  }

  function allocationMatchesActiveApp(alloc, activeGroupIds) {
    if (!activeGroupIds || activeGroupIds.length === 0) return true;
    var gid = alloc && alloc.selling_plan_group_id;
    if (gid === undefined || gid === null) return false;
    var key = String(gid);
    return activeGroupIds.indexOf(key) !== -1;
  }

  function filterSellingPlanAllocations(allocations, activeGroupIds) {
    if (!allocations || !allocations.length) return [];
    if (!activeGroupIds || !activeGroupIds.length) return allocations.slice();
    var out = [];
    for (var i = 0; i < allocations.length; i++) {
      if (allocationMatchesActiveApp(allocations[i], activeGroupIds)) out.push(allocations[i]);
    }
    return out;
  }

  function getProductDataFromCard(card) {
    var script = card.querySelector('[data-bundle-product-json]');
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function getVariantFromProductData(productData) {
    if (!productData || !productData.variants || productData.variants.length === 0) return null;
    return productData.variants[0];
  }

  function getSubscriptionPrice(variant, sellingPlanId) {
    if (!sellingPlanId || !variant.selling_plan_allocations) return null;
    for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
      var alloc = variant.selling_plan_allocations[i];
      if (alloc.selling_plan && alloc.selling_plan.id === sellingPlanId) {
        return alloc.price != null ? alloc.price : null;
      }
    }
    return null;
  }

  function hasSellingPlan(variant, sellingPlanId) {
    return getSubscriptionPrice(variant, sellingPlanId) !== null;
  }

  function initBundleBuilder(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var discounts = {
      2: getDiscountCents(root, 2),
      4: getDiscountCents(root, 4),
      6: getDiscountCents(root, 6)
    };

    var discountMode = root.getAttribute('data-discount-mode') === 'dollars' ? 'dollars' : 'percentage';

    var enableSize2 = root.getAttribute('data-enable-size-2') === 'true';
    var enableSize4 = root.getAttribute('data-enable-size-4') !== 'false';
    var enableSize6 = root.getAttribute('data-enable-size-6') !== 'false';
    var defaultSize = parseInt(root.getAttribute('data-default-size') || '4', 10);
    if (defaultSize === 2 && !enableSize2) defaultSize = enableSize4 ? 4 : 6;
    if (defaultSize === 4 && !enableSize4) defaultSize = enableSize6 ? 6 : (enableSize2 ? 2 : 4);
    if (defaultSize === 6 && !enableSize6) defaultSize = enableSize4 ? 4 : (enableSize2 ? 2 : 4);
    var defaultFreq = root.getAttribute('data-default-frequency') || 'one-time';
    var buttonAddMoreTemplate = root.getAttribute('data-button-add-more') || 'Add X More';
    var buttonComplete = root.getAttribute('data-button-complete') || 'Add Bundle to Cart';

    var activeSellingPlanGroupIds = parseActiveSellingPlanGroupIds(root);

    var maxSlots = 6;
    if (enableSize6) maxSlots = 6;
    else if (enableSize4) maxSlots = 4;
    else if (enableSize2) maxSlots = 2;

    var submitting = false;
    var state = {
      bundleSize: defaultSize,
      selectedItems: [],
      frequency: defaultFreq,
      sellingPlanId: null
    };

    var slotsContainer = root.querySelector('[data-bundle-builder-selected-products]');
    var slots = root.querySelectorAll('[data-bundle-slot]');
    var progressCurrent = root.querySelector('[data-bundle-progress-current]');
    var progressMax = root.querySelector('[data-bundle-progress-max]');
    var sizeOptions = root.querySelector('[data-bundle-size-options]');
    var sizeButtons = root.querySelectorAll('[data-bundle-size-btn]');
    var frequencyInputs = root.querySelectorAll('[data-bundle-frequency-input]');
    var intervalSelect = root.querySelector('[data-bundle-interval-select]');
    var intervalWrap = root.querySelector('[data-bundle-interval-wrap]');
    var subtotalEl = root.querySelector('[data-bundle-subtotal]');
    var finalPriceEl = root.querySelector('[data-bundle-final-price]');
    var otpPriceEl = root.querySelector('[data-bundle-otp-price]');
    var subPriceEl = root.querySelector('[data-bundle-sub-price]');
    var otpCompareEl = root.querySelector('[data-bundle-otp-compare]');
    var subCompareEl = root.querySelector('[data-bundle-sub-compare]');
    var atcBtn = root.querySelector('[data-bundle-atc]');
    var atcTextAddMore = root.querySelector('[data-bundle-atc-text-add-more]');
    var atcTextComplete = root.querySelector('[data-bundle-atc-text-complete]');

    var errorNode = document.createElement('p');
    errorNode.className = 'bundle-builder__error';
    errorNode.id = 'bundle-error-' + sectionId;
    errorNode.setAttribute('role', 'alert');
    errorNode.hidden = true;
    if (atcBtn) { atcBtn.before(errorNode); atcBtn.setAttribute('aria-describedby', errorNode.id); }
    function showError(message) {
      [errorNode, stickyError].forEach(function (node) { if (node) { node.textContent = message || ''; node.hidden = !message; } });
    }

    var stickyBar = root.querySelector('[data-bundle-sticky-bar]');
    var stickyCount = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-count]') : null;
    var stickyMax = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-max]') : null;
    var stickyExpandBtn = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-expand-btn]') : null;
    var stickyProductsWrap = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-products-wrap]') : null;
    var stickySlots = stickyBar ? stickyBar.querySelectorAll('[data-bundle-sticky-slot]') : [];
    var stickyPlan = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-plan]') : null;
    var stickyAtcWrap = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-atc-wrap]') : null;
    var stickyAtcBtn = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-atc-btn]') : null;
    var stickyError = null;
    if (stickyAtcBtn) {
      stickyError = errorNode.cloneNode(false);
      stickyError.id += '-sticky';
      stickyAtcBtn.before(stickyError);
      stickyAtcBtn.setAttribute('aria-describedby', stickyError.id);
    }
    var stickyAtcPrice = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-atc-price]') : null;
    var stickyFreqInputs = stickyBar ? stickyBar.querySelectorAll('[data-bundle-sticky-frequency-input]') : [];
    var stickyIntervalSelect = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-interval-select]') : null;
    var stickyIntervalWrap = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-interval-wrap]') : null;
    var stickyOtpPrice = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-otp-price]') : null;
    var stickySubPrice = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-sub-price]') : null;
    var stickyOtpCompare = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-otp-compare]') : null;
    var stickySubCompare = stickyBar ? stickyBar.querySelector('[data-bundle-sticky-sub-compare]') : null;

    // Percentage: sum floor(per-unit discount) to match Shopify line-level allocation (qty 1 per line).
    function getDiscountCentsForBundle(size, otpSubtotalCents, selectedItems) {
      var raw = discounts[size] || 0;
      if (discountMode === 'dollars') return raw;
      if (selectedItems && selectedItems.length > 0) {
        var pct = raw;
        var sum = 0;
        for (var i = 0; i < selectedItems.length; i++) {
          var unitCents = selectedItems[i].price;
          sum += Math.floor((unitCents * pct) / 100);
        }
        return sum;
      }
      return Math.round((otpSubtotalCents || 0) * raw / 100);
    }

    function setBundleSize(size) {
      var newSize = parseInt(size, 10);
      if (state.bundleSize === newSize) return;
      state.bundleSize = newSize;
      if (state.selectedItems.length > newSize) {
        state.selectedItems = state.selectedItems.slice(0, newSize);
      }
      updateSizeButtons();
      updateSlotsVisibility();
      renderSlots();
      updateProgress();
      updatePricing();
      updateAtcButton();
      updateStickyBar();
      updateProductCards();
    }

    function updateSizeButtons() {
      sizeButtons.forEach(function (btn) {
        var size = parseInt(btn.getAttribute('data-bundle-size'), 10);
        var isSelected = size === state.bundleSize;
        btn.setAttribute('aria-pressed', isSelected);
        btn.classList.toggle('btn--primary', isSelected);
        btn.classList.toggle('btn--outline', !isSelected);
      });
    }

    function updateSlotsVisibility() {
      var n = state.bundleSize;
      slots.forEach(function (slot, i) {
        var visible = i < n;
        slot.style.display = visible ? '' : 'none';
        slot.setAttribute('data-bundle-slot-visible', visible ? 'true' : 'false');
      });
      if (progressMax) progressMax.textContent = n;
    }

    function addItem(card) {
      if (state.selectedItems.length >= state.bundleSize) return;
      var variantId = card.getAttribute('data-bundle-product-variant-id');
      var handle = card.getAttribute('data-bundle-product-handle');
      if (card.hasAttribute('data-bundle-product-unavailable')) return;

      var productData = getProductDataFromCard(card);
      var variant = productData ? getVariantFromProductData(productData) : null;
      if (!variant) return;

      var imageSrc = '';
      if (productData && productData.featured_image && productData.featured_image.src) {
        imageSrc = productData.featured_image.src;
      } else {
        var img = card.querySelector('img');
        if (img) imageSrc = img.src || '';
      }

      state.selectedItems.push({
        variantId: parseInt(variantId, 10),
        productHandle: handle,
        title: (productData && productData.title) || (function () { var t = card.querySelector('.bundle-builder__product-title a'); return t ? (t.textContent || '').trim() : ''; })() || 'Product',
        imageUrl: imageSrc,
        price: variant.price,
        compareAtPrice: variant.compare_at_price || 0,
        sellingPlanAllocations: filterSellingPlanAllocations(variant.selling_plan_allocations || [], activeSellingPlanGroupIds)
      });

      renderSlots();
      updateProgress();
      updatePricing();
      updateAtcButton();
      updateProductCards();
    }

    function removeItem(index) {
      state.selectedItems.splice(index, 1);
      renderSlots();
      updateProgress();
      updatePricing();
      updateAtcButton();
      updateProductCards();
    }

    function countInBundle(variantId) {
      var id = parseInt(variantId, 10);
      var count = 0;
      state.selectedItems.forEach(function (item) {
        if (item.variantId === id) count++;
      });
      return count;
    }

    function removeOneByVariantId(variantId) {
      var id = parseInt(variantId, 10);
      for (var i = state.selectedItems.length - 1; i >= 0; i--) {
        if (state.selectedItems[i].variantId === id) {
          removeItem(i);
          return;
        }
      }
    }

    function updateProductCards() {
      var bundleFull = state.selectedItems.length >= state.bundleSize;
      root.querySelectorAll('[data-bundle-product-card]').forEach(function (card) {
        var variantId = card.getAttribute('data-bundle-product-variant-id');
        if (!variantId) return;
        var count = countInBundle(variantId);
        var addBtn = card.querySelector('[data-bundle-add-btn]');
        var quantityWrap = card.querySelector('[data-bundle-quantity-wrap]');
        var quantityDisplay = card.querySelector('[data-bundle-quantity-display]');
        var quantityPlus = card.querySelector('[data-bundle-quantity-plus]');
        var addImage = card.querySelector('[data-bundle-add-image]');
        var unavailable = card.hasAttribute('data-bundle-product-unavailable');

        var imageDisabled = unavailable || (bundleFull && (count === 0 || (quantityPlus && quantityPlus.disabled)));
        if (addImage) addImage.setAttribute('aria-disabled', imageDisabled ? 'true' : 'false');

        if (count > 0) {
          if (addBtn) addBtn.hidden = true;
          if (quantityWrap) {
            quantityWrap.hidden = false;
            if (quantityDisplay) quantityDisplay.textContent = count;
            if (quantityPlus) {
              quantityPlus.disabled = bundleFull || unavailable;
              quantityPlus.setAttribute('aria-disabled', bundleFull || unavailable ? 'true' : 'false');
            }
          }
        } else {
          if (addBtn) {
            addBtn.hidden = false;
            addBtn.disabled = bundleFull || unavailable;
            addBtn.setAttribute('aria-disabled', bundleFull || unavailable ? 'true' : 'false');
          }
          if (quantityWrap) quantityWrap.hidden = true;
        }
      });
    }

    function renderSlots() {
      var items = state.selectedItems;
      slots.forEach(function (slot, i) {
        if (i >= state.bundleSize) return;
        var placeholder = slot.querySelector('[data-bundle-slot-placeholder]');
        var filled = slot.querySelector('[data-bundle-slot-filled]');
        var item = items[i];

        if (item) {
          if (placeholder) placeholder.hidden = true;
          if (filled) {
            filled.hidden = false;
            var img = filled.querySelector('[data-bundle-slot-image]');
            var titleEl = filled.querySelector('[data-bundle-slot-title]');
            if (img) { img.src = item.imageUrl || ''; img.alt = item.title; }
            if (titleEl) titleEl.textContent = item.title;
          }
          slot.setAttribute('data-bundle-builder-selected-variant-id', item.variantId);
        } else {
          if (placeholder) placeholder.hidden = false;
          if (filled) {
            filled.hidden = true;
            var imgEl = filled.querySelector('[data-bundle-slot-image]');
            if (imgEl) { imgEl.src = ''; imgEl.alt = ''; }
            var titleElEmpty = filled.querySelector('[data-bundle-slot-title]');
            if (titleElEmpty) titleElEmpty.textContent = '';
          }
          slot.setAttribute('data-bundle-builder-selected-variant-id', '');
        }
      });
    }

    function updateProgress() {
      if (progressCurrent) progressCurrent.textContent = state.selectedItems.length;
    }

    function getIntervalSelectEl() {
      if (stickyIntervalSelect && stickyBar && window.getComputedStyle(stickyBar).display !== 'none') {
        return stickyIntervalSelect;
      }
      return intervalSelect;
    }

    function normalizePlanLabel(s) {
      if (s == null) return '';
      return String(s).trim().replace(/\s+/g, ' ');
    }

    function idsEqualSellingPlan(planIdA, planIdB) {
      if (planIdA == null || planIdB == null || planIdA === '' || planIdB === '') return false;
      return Number(planIdA) === Number(planIdB);
    }

    /**
     * Resolves variant allocation for ATC + pricing: prefer dropdown plan ID when this variant offers it,
     * else fall back to label match (plans often have different IDs per product for the same UI text).
     */
    function findAllocationForBundleItem(item, dropdownPlanId, planNameLabel) {
      var allocs = item.sellingPlanAllocations;
      if (!allocs || !allocs.length) return null;

      var pid = dropdownPlanId != null && dropdownPlanId !== '' ? Number(dropdownPlanId) : NaN;
      if (!isNaN(pid)) {
        for (var i = 0; i < allocs.length; i++) {
          var a = allocs[i];
          if (a.selling_plan && idsEqualSellingPlan(a.selling_plan.id, pid) && a.price != null) {
            return { alloc: a, matchedBy: 'dropdown_plan_id' };
          }
        }
      }

      if (planNameLabel) {
        var targetTrim = String(planNameLabel).trim();
        var normTarget = normalizePlanLabel(targetTrim);
        var normTargetLc = normTarget.toLowerCase();

        for (var j = 0; j < allocs.length; j++) {
          var b = allocs[j];
          if (!b.selling_plan || b.price == null) continue;
          var bn = String(b.selling_plan.name).trim();
          if (bn === targetTrim) {
            return { alloc: b, matchedBy: 'plan_name_exact' };
          }
        }
        for (var k = 0; k < allocs.length; k++) {
          var c = allocs[k];
          if (!c.selling_plan || c.price == null) continue;
          if (normalizePlanLabel(c.selling_plan.name) === normTarget) {
            return { alloc: c, matchedBy: 'plan_name_normalized' };
          }
        }
        for (var m = 0; m < allocs.length; m++) {
          var d = allocs[m];
          if (!d.selling_plan || d.price == null) continue;
          if (normalizePlanLabel(d.selling_plan.name).toLowerCase() === normTargetLc) {
            return { alloc: d, matchedBy: 'plan_name_ci' };
          }
        }
      }

      return null;
    }

    /** Only treat option value as a Shopify selling_plan id when it is digits-only (name-based values skip id match). */
    function parseNumericSellingPlanOptionValue(val) {
      if (val == null || String(val).trim() === '') return null;
      var raw = String(val).trim();
      if (!/^\d+$/.test(raw)) return null;
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    }

    function getResolvedDropdownSellingPlanId() {
      var el = getIntervalSelectEl();
      var fromSelect = el && el.value ? parseNumericSellingPlanOptionValue(el.value) : null;
      if (fromSelect != null) return fromSelect;
      return state.sellingPlanId || null;
    }

    function getLinePrice(item) {
      if (state.frequency === 'subscribe' && item.sellingPlanAllocations && item.sellingPlanAllocations.length) {
        var planName = getSelectedPlanName();
        var dropdownId = getResolvedDropdownSellingPlanId();
        var resolved = findAllocationForBundleItem(item, dropdownId, planName);
        if (resolved && resolved.alloc.price != null) return resolved.alloc.price;
      }
      return state.frequency === 'subscribe' ? null : item.price;
    }

    function getSubscriptionTotalCents() {
      var total = 0;
      for (var i = 0; i < state.selectedItems.length; i++) {
        var match = findAllocationForBundleItem(state.selectedItems[i], getResolvedDropdownSellingPlanId(), getSelectedPlanName());
        if (!match || !match.alloc.selling_plan || !Number.isFinite(match.alloc.price) || match.alloc.price < 0) return null;
        total += match.alloc.price;
      }
      return total;
    }

    function updatePricing() {
      var otpSubtotalCents = 0;
      state.selectedItems.forEach(function (item) {
        otpSubtotalCents += item.price;
      });
      var discountCents = getDiscountCentsForBundle(state.bundleSize, otpSubtotalCents, state.selectedItems);
      var otpFinalCents = Math.max(0, otpSubtotalCents - discountCents);
      var subDisplayCents = getSubscriptionTotalCents();

      root.querySelectorAll('[data-bundle-subscription-label]').forEach(function (label) {
        var saving = otpSubtotalCents > 0 && subDisplayCents != null ? Math.round((otpSubtotalCents - subDisplayCents) / otpSubtotalCents * 100) : 0;
        label.textContent = saving > 0 ? 'Subscribe & Save ' + saving + '%' : 'Subscribe';
      });
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(otpSubtotalCents);
      }
      if (finalPriceEl) {
        finalPriceEl.textContent = formatMoney(state.frequency === 'subscribe' ? subDisplayCents : otpFinalCents);
      }
      if (otpPriceEl) otpPriceEl.textContent = formatMoney(otpFinalCents);
      if (subPriceEl) subPriceEl.textContent = formatMoney(subDisplayCents);
      if (otpCompareEl) {
        otpCompareEl.textContent = formatMoney(otpSubtotalCents);
        otpCompareEl.hidden = otpSubtotalCents <= 0;
      }
      if (subCompareEl) {
        subCompareEl.textContent = formatMoney(otpSubtotalCents);
        subCompareEl.hidden = otpSubtotalCents <= 0 || subDisplayCents == null;
      }
    }

    function updateAtcButton() {
      var count = state.selectedItems.length;
      var needed = state.bundleSize;
      var complete = count === needed && needed > 0;

      var unavailable = state.frequency === 'subscribe' && getSubscriptionTotalCents() == null;
      if (complete && unavailable) showError('This delivery interval is not available for every selected item. Choose another interval or one-time purchase.');
      else if (!submitting) showError('');
      if (atcBtn) {
        atcBtn.disabled = !complete || unavailable || submitting;
        atcBtn.setAttribute('aria-disabled', String(atcBtn.disabled));
      }
      if (atcTextAddMore) {
        atcTextAddMore.textContent = buttonAddMoreTemplate.replace(/\bX\b/i, (needed - count).toString());
        atcTextAddMore.classList.toggle('hidden', complete);
      }
      if (atcTextComplete) {
        atcTextComplete.classList.toggle('hidden', !complete);
      }
      updateStickyBar();
    }

    function updateStickyBar() {
      if (!stickyBar) return;
      var count = state.selectedItems.length;
      var needed = state.bundleSize;
      var complete = count === needed && needed > 0;

      if (stickyCount) stickyCount.textContent = count;
      if (stickyMax) stickyMax.textContent = needed;
      var stickyAddMore = stickyBar.querySelector('[data-bundle-sticky-add-more]');
      if (stickyAddMore) {
        stickyAddMore.textContent = complete ? '' : '...Add more';
        stickyAddMore.style.display = complete ? 'none' : '';
      }

      stickySlots.forEach(function (slot, i) {
        var visible = i < needed;
        slot.style.display = visible ? '' : 'none';
        var placeholder = slot.querySelector('[data-bundle-sticky-slot-placeholder]');
        var filled = slot.querySelector('[data-bundle-sticky-slot-filled]');
        var item = state.selectedItems[i];
        if (item) {
          if (placeholder) placeholder.hidden = true;
          if (filled) {
            filled.hidden = false;
            var img = filled.querySelector('[data-bundle-sticky-slot-image]');
            var titleEl = filled.querySelector('[data-bundle-sticky-slot-title]');
            if (img) { img.src = item.imageUrl || ''; img.alt = item.title; }
            if (titleEl) titleEl.textContent = item.title;
          }
          slot.setAttribute('data-bundle-builder-selected-variant-id', item.variantId);
        } else {
          if (placeholder) placeholder.hidden = false;
          if (filled) {
            filled.hidden = true;
            var imgSticky = filled.querySelector('[data-bundle-sticky-slot-image]');
            if (imgSticky) { imgSticky.src = ''; imgSticky.alt = ''; }
            var titleSticky = filled.querySelector('[data-bundle-sticky-slot-title]');
            if (titleSticky) titleSticky.textContent = '';
          }
          slot.setAttribute('data-bundle-builder-selected-variant-id', '');
        }
      });

      if (stickyPlan) {
        stickyPlan.hidden = !complete;
      }
      if (stickyAtcWrap) {
        stickyAtcWrap.hidden = !complete;
      }

      if (complete) {
        var otpSub = 0;
        state.selectedItems.forEach(function (item) { otpSub += item.price; });
        var discountCents = getDiscountCentsForBundle(state.bundleSize, otpSub, state.selectedItems);
        var otpFinalSticky = Math.max(0, otpSub - discountCents);
        var subDisplaySticky = getSubscriptionTotalCents();
        if (stickyOtpPrice) stickyOtpPrice.textContent = formatMoney(otpFinalSticky);
        if (stickySubPrice) stickySubPrice.textContent = formatMoney(subDisplaySticky);
        if (stickyOtpCompare) {
          stickyOtpCompare.textContent = formatMoney(otpSub);
          stickyOtpCompare.hidden = otpSub <= 0;
        }
        if (stickySubCompare) {
          stickySubCompare.textContent = formatMoney(otpSub);
          stickySubCompare.hidden = otpSub <= 0 || subDisplaySticky == null;
        }
        if (stickyAtcPrice) stickyAtcPrice.textContent = formatMoney(state.frequency === 'subscribe' ? subDisplaySticky : otpFinalSticky);
        if (stickyAtcBtn) {
          stickyAtcBtn.disabled = submitting || (state.frequency === 'subscribe' && subDisplaySticky == null);
          stickyAtcBtn.setAttribute('aria-disabled', String(stickyAtcBtn.disabled));
        }
        stickyFreqInputs.forEach(function (input) {
          input.checked = input.value === state.frequency;
        });
        if (stickyIntervalSelect && intervalSelect) {
          stickyIntervalSelect.value = intervalSelect.value;
          if (stickyIntervalWrap) stickyIntervalWrap.style.display = state.frequency === 'subscribe' ? '' : 'none';
        } else if (stickyIntervalSelect) {
          stickyIntervalSelect.value = stickyIntervalSelect.options[0] ? stickyIntervalSelect.options[0].value : '';
          if (stickyIntervalWrap) stickyIntervalWrap.style.display = state.frequency === 'subscribe' ? '' : 'none';
        }
      } else {
        if (stickyAtcBtn) {
          stickyAtcBtn.disabled = true;
          stickyAtcBtn.setAttribute('aria-disabled', 'true');
        }
      }
    }

    function setFrequency(value) {
      state.frequency = value;
      if (intervalWrap) intervalWrap.style.display = value === 'subscribe' ? '' : 'none';
      var sourceSelect = intervalSelect;
      if (stickyIntervalSelect && stickyBar && window.getComputedStyle(stickyBar).display !== 'none') {
        sourceSelect = stickyIntervalSelect;
      }
      if (value === 'subscribe' && sourceSelect) {
        state.sellingPlanId = parseNumericSellingPlanOptionValue(sourceSelect.value);
      } else {
        state.sellingPlanId = null;
      }
      updatePricing();
      updateAtcButton();
    }

    function getSelectedPlanName() {
      var source = getIntervalSelectEl();
      if (!source || source.selectedIndex < 0) return null;
      var opt = source.options[source.selectedIndex];
      return opt ? (opt.textContent || '').trim() : null;
    }

    function addToCart() {
      if (submitting || state.selectedItems.length !== state.bundleSize) return;
      if (state.frequency === 'subscribe' && getSubscriptionTotalCents() == null) {
        showError('This delivery interval is not available for every selected item. Choose another interval or one-time purchase.');
        return;
      }

      var bundleId = sectionId + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var targetPlanName = state.frequency === 'subscribe' ? getSelectedPlanName() : null;
      var dropdownPlanId = state.frequency === 'subscribe' ? getResolvedDropdownSellingPlanId() : null;

      var items = state.selectedItems.map(function (item) {
        var variantId = parseInt(item.variantId, 10);
        if (isNaN(variantId) || variantId <= 0) return null;
        var match =
          state.frequency === 'subscribe'
            ? findAllocationForBundleItem(item, dropdownPlanId, targetPlanName)
            : null;
        var sellingPlanId = match && match.alloc && match.alloc.selling_plan ? match.alloc.selling_plan.id : null;

        var line = {
          id: variantId,
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_size: state.bundleSize.toString()
          }
        };
        if (sellingPlanId) line.selling_plan = sellingPlanId;
        return line;
      }).filter(Boolean);

      if (items.length !== state.bundleSize) { showError('One of these items is unavailable. Please rebuild your bundle.'); return; }

      function setLoading(loading) {
        submitting = loading;
        if (atcBtn) {
          atcBtn.disabled = loading;
          atcBtn.setAttribute('aria-disabled', loading ? 'true' : 'false');
          atcBtn.classList.toggle('is-loading', loading);
          var panelSpinner = atcBtn.querySelector('[data-bundle-atc-spinner]');
          if (panelSpinner) panelSpinner.hidden = !loading;
        }
        if (stickyAtcBtn) {
          stickyAtcBtn.disabled = loading;
          stickyAtcBtn.setAttribute('aria-disabled', loading ? 'true' : 'false');
          stickyAtcBtn.classList.toggle('is-loading', loading);
          var stickySpinner = stickyAtcBtn.querySelector('[data-bundle-sticky-atc-spinner]');
          if (stickySpinner) stickySpinner.hidden = !loading;
        }
      }

      showError('');
      setLoading(true);

      (window.CaffeineCart ? window.CaffeineCart.add(items).then(function () { return { json: function () { return {}; } }; }) : fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            throw new Error(data.description || 'Could not add to cart');
          }
          setLoading(false);
          updateAtcButton();

          if (window.CaffeineCart) return;

          var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';

          window.location.assign(cartUrl);
        })
        .catch(function (err) {
          setLoading(false);
          updateAtcButton();
          showError(err.message || 'Could not add to cart. Please try again.');
        });
    }

    function bindEvents() {
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var size = btn.getAttribute('data-bundle-size');
          setBundleSize(size);
        });
      });

      root.querySelectorAll('[data-bundle-add-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('[data-bundle-product-card]');
          if (card) addItem(card);
        });
      });

      root.addEventListener('click', function (e) {
        var addImage = e.target.closest('[data-bundle-add-image]');
        if (!addImage) return;
        if (addImage.getAttribute('aria-disabled') === 'true') return;
        var card = addImage.closest('[data-bundle-product-card]');
        if (!card || card.hasAttribute('data-bundle-product-unavailable')) return;
        if (state.selectedItems.length < state.bundleSize) {
          addItem(card);
          return;
        }
        var variantId = card.getAttribute('data-bundle-product-variant-id');
        if (countInBundle(variantId) > 0) {
          var plus = card.querySelector('[data-bundle-quantity-plus]');
          if (plus && !plus.disabled) addItem(card);
        }
      });

      root.addEventListener('keydown', function (e) {
        var addImage = e.target.closest('[data-bundle-add-image]');
        if (!addImage || addImage.getAttribute('aria-disabled') === 'true') return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        var card = addImage.closest('[data-bundle-product-card]');
        if (!card || card.hasAttribute('data-bundle-product-unavailable')) return;
        if (state.selectedItems.length < state.bundleSize) {
          addItem(card);
          return;
        }
        var variantId = card.getAttribute('data-bundle-product-variant-id');
        if (countInBundle(variantId) > 0) {
          var plus = card.querySelector('[data-bundle-quantity-plus]');
          if (plus && !plus.disabled) addItem(card);
        }
      });

      frequencyInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          setFrequency(input.value);
        });
      });

      if (intervalSelect) {
        intervalSelect.addEventListener('change', function () {
          state.sellingPlanId = parseNumericSellingPlanOptionValue(intervalSelect.value);
          if (stickyIntervalSelect) stickyIntervalSelect.value = intervalSelect.value;
          updatePricing();
          updateAtcButton();
        });
      }

      if (atcBtn) {
        atcBtn.addEventListener('click', function () {
          addToCart();
        });
      }

      root.addEventListener('click', function (e) {
        var panelRemove = e.target.closest('[data-bundle-slot-remove]');
        var stickyRemove = e.target.closest('[data-bundle-sticky-slot-remove]');
        var slot = panelRemove ? (panelRemove.closest('[data-bundle-slot]') || null) : (stickyRemove ? stickyRemove.closest('[data-bundle-sticky-slot]') : null);
        if (slot) {
          var idx = slot.getAttribute('data-slot-index');
          if (idx !== null && idx !== '') {
            removeItem(parseInt(idx, 10));
            return;
          }
        }
        var quantityMinus = e.target.closest('[data-bundle-quantity-minus]');
        var quantityPlus = e.target.closest('[data-bundle-quantity-plus]');
        var card = quantityMinus ? quantityMinus.closest('[data-bundle-product-card]') : (quantityPlus ? quantityPlus.closest('[data-bundle-product-card]') : null);
        if (card) {
          var variantId = card.getAttribute('data-bundle-product-variant-id');
          if (quantityMinus) {
            removeOneByVariantId(variantId);
          } else if (quantityPlus && !quantityPlus.disabled) {
            addItem(card);
          }
        }
      });

      if (stickyExpandBtn && stickyProductsWrap) {
        stickyExpandBtn.addEventListener('click', function () {
          var expanded = stickyBar.getAttribute('data-expanded') === 'true';
          stickyBar.setAttribute('data-expanded', !expanded);
          stickyExpandBtn.setAttribute('aria-expanded', !expanded);
          stickyProductsWrap.hidden = expanded;
        });
      }

      stickyFreqInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          setFrequency(input.value);
          if (frequencyInputs.length) {
            frequencyInputs.forEach(function (panelInput) {
              if (panelInput.value === input.value) panelInput.checked = true;
            });
          }
          if (intervalSelect && stickyIntervalSelect) intervalSelect.value = stickyIntervalSelect.value;
        });
      });

      if (stickyIntervalSelect) {
        stickyIntervalSelect.addEventListener('change', function () {
          state.sellingPlanId = parseNumericSellingPlanOptionValue(stickyIntervalSelect.value);
          if (intervalSelect) intervalSelect.value = stickyIntervalSelect.value;
          updatePricing();
          updateAtcButton();
        });
      }

      if (stickyAtcBtn) {
        stickyAtcBtn.addEventListener('click', function () {
          addToCart();
        });
      }
    }

    updateSizeButtons();
    updateSlotsVisibility();
    // Prefer the actual monthly allocation; never invent a selling-plan ID.
    if (intervalSelect) {
      var monthlyOption = Array.from(intervalSelect.options).find(function (option) {
        return /^(?:every\s+)?(?:1\s+month|monthly)(?:\b|$)/i.test(option.textContent.trim());
      });
      if (monthlyOption) intervalSelect.value = monthlyOption.value;
    }
    if (intervalSelect && stickyIntervalSelect && intervalSelect.options.length) {
      stickyIntervalSelect.innerHTML = intervalSelect.innerHTML;
      stickyIntervalSelect.value = intervalSelect.value;
    }
    setFrequency(defaultFreq);
    if (intervalSelect && defaultFreq === 'subscribe') {
      state.sellingPlanId = parseNumericSellingPlanOptionValue(intervalSelect.value);
    }
    if (intervalWrap) intervalWrap.style.display = defaultFreq === 'subscribe' ? '' : 'none';
    renderSlots();
    updateProgress();
    updatePricing();
    updateAtcButton();
    updateProductCards();
    bindEvents();
    if (stickyBar) stickyBar.setAttribute('data-expanded', 'false');
  }

  function init() {
    document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bundle-builder]');
    if (root) initBundleBuilder(root);
  });
})();
